import React from "react";
import { HeaderModule } from "../../components/home/HeaderModule";
import { ArticleOutlined, DesktopWindowsOutlined, LocalPrintshopOutlined } from "@mui/icons-material";
import { ActionsBar } from "../../components/ActionsBar";
import { TableModule } from "../../components/home/TableModule";
import { useAssets } from "../../hooks/activos/useAssets";
import { IconButton, Tooltip } from "@mui/material";
import { motion, AnimatePresence } from 'framer-motion';
import { QrPrintAssets } from "../../components/activos/assets/QrPrintAssets";
import { PrintAssetsUser } from "../../components/activos/assets/PrintAssetsUser";

export const Assets = () => {

    const { columns, assets, addAsset, qrPrint, printQrAssets, qrPrintRef, assetsPrintRef, generateAssetForm, searchAsset, dataFormat } = useAssets();

	return (
        <>
            <HeaderModule
                icon={ <DesktopWindowsOutlined htmlColor="rgba(0, 0, 0, .6)" /> }
                title='Activos'
            />

            <ActionsBar
                addAction={ addAsset } 
                module='activos' 
                searchAction={ searchAsset } 
                searchPlaceholder='Placa'
                component={
                    <>
                        {
                            assets.length > 0 && (
                                <Tooltip title='Lista de activos'>
                                    <IconButton onClick={ generateAssetForm }>
                                        <ArticleOutlined />
                                    </IconButton>
                                </Tooltip>
                            )
                        }

                        <AnimatePresence>
                            {
                                qrPrint.length > 0 && (
                                    <motion.div
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                    >
                                        <Tooltip title='Imprimir'>
                                            <IconButton onClick={ printQrAssets }>
                                                <LocalPrintshopOutlined />
                                            </IconButton>
                                        </Tooltip>
                                    </motion.div>
                                )
                            }
                        </AnimatePresence>
                    
                    </>
                }
            />
                
            <div style={{ display: 'none' }}>
                <QrPrintAssets qrPrint={ qrPrint } ref={ qrPrintRef } />
            </div>

            {
                Object.values(dataFormat).length > 0 && (
                    <div style={{ display: 'none' }}>
                        <PrintAssetsUser data={ dataFormat } ref={ assetsPrintRef } />
                    </div>
                )
            }

            <TableModule
                columns={ columns }
                rows={ assets }
                styles={{
                    background: '#fff',
                    borderRadius: 6,
                    marginTop: 10,
                }}
            />      
        </>
    )
}